/**
 * De tekst voor een fout bij het opslaan van een klant.
 *
 * De naamregel zit in de backend (klant_service.bepaal_naam); die weigert met een code
 * (NAAMCODES). Hier alleen de vertaling van die code;
 * een andere fout toont zijn eigen melding. Alleen weergave: hier wordt niets bepaald.
 */
import { foutMelding } from './apiFout'

const NAAMCODES = ['KLANT_NAAM_VERPLICHT', 'KLANT_BEDRIJFSNAAM_VERPLICHT', 'KLANT_NAAM_VOLGT_UIT_VELDEN']

export function klantFoutTekst(t, err, standaard) {
  const { code, message } = foutMelding(err, standaard)
  if (NAAMCODES.includes(code)) {
    return t(`klanten.naamFout.${code}`, { defaultValue: message })
  }
  return message
}
